import { render, staticRenderFns } from "./demandUser.vue?vue&type=template&id=537bcae4&scoped=true"
import script from "./demandUser.vue?vue&type=script&lang=js"
export * from "./demandUser.vue?vue&type=script&lang=js"
import style0 from "./demandUser.vue?vue&type=style&index=0&id=537bcae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537bcae4",
  null
  
)

export default component.exports